import { render, staticRenderFns } from "./UploadList.vue?vue&type=template&id=4a625f0e"
import script from "./UploadList.vue?vue&type=script&lang=js"
export * from "./UploadList.vue?vue&type=script&lang=js"
import style0 from "./UploadList.vue?vue&type=style&index=0&id=4a625f0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports